














































import Vue, { PropType } from "vue";

export interface PaypalCustomCardFieldsData {
  isDeleted: boolean;
}

export interface GoldPurchasePaypalExistCardInformationFieldProps {
  hasExistCard: boolean;
  isUsingAutocharge: boolean;
  currentCard: any;
  autochargeInputUrl: string;
  deleteApiUrl: string;
  returnUrl: string;
  errorUrl: string;
  csrfToken: string;
  updateIsBusy: any;
  translationResources: object;
}

export default Vue.extend({
  name: "vc-gold-purchase-paypal-exist-card-information-field",
  props: {
    hasExistCard: {
      type: Boolean as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["hasExistCard"]
      >,
      default: false
    },
    isUsingAutocharge: {
      type: Boolean as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["isUsingAutocharge"]
      >,
      default: false
    },
    currentCard: {
      type: [Object, Array] as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["currentCard"]
      >,
      default: () => {}
    },
    autochargeInputUrl: {
      type: String as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["autochargeInputUrl"]
      >,
      default: ""
    },
    deleteApiUrl: {
      type: String as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["deleteApiUrl"]
      >,
      default: ""
    },
    returnUrl: {
      type: String as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["returnUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["errorUrl"]
      >,
      default: ""
    },
    csrfToken: {
      type: String as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["csrfToken"]
      >,
      default: ""
    },
    //mutationsToProps
    updateIsBusy: {
      type: Function as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["updateIsBusy"]
      >,
      default: () => {}
    },
    translationResources: {
      type: Object as PropType<
        GoldPurchasePaypalExistCardInformationFieldProps["translationResources"]
      >,
      default: () => {}
    }
  },
  data(): PaypalCustomCardFieldsData {
    return {
      isDeleted: false
    };
  },
  methods: {
    catchIsDeleted() {
      this.isDeleted = true;
      this.$emit("catch-is-deleted");
    }
  }
});
